<template>
  <div class="color-box">
    <div class="color-cards blue-box">
      <p>{{ mydata.teacherCard3?.title }}</p>
      <div class="bar"></div>
      <p>
        {{ mydata.teacherCard3?.descr }}
      </p>
      <img src="@/assets/Vector.png" alt="" />
      <!-- <img v-complete:src="info1.image" alt="" /> -->
      <a :href="mydata.teacherCard3?.url" target="_blank">
        <el-button type="primary" round class="elButton">
          {{ mydata.teacherCard3?.button_text }}</el-button
        ></a
      >
    </div>
    <div class="color-cards green-box">
      <p>{{ mydata.teacherCard2?.title }}</p>
      <div class="bar"></div>
      <p>
        {{ mydata.teacherCard2?.descr }}
      </p>
      <img src="@/assets/Vector (2).png" alt="" />
      <a :href="mydata.teacherCard2?.url" target="_blank">
        <el-button type="primary" round class="elButton">{{
          mydata.teacherCard2?.button_text
        }}</el-button></a
      >

      <!-- <img src="@/assets/Vector.png" alt=""> -->
    </div>
    <div class="color-cards yellow-box">
      <p>{{ mydata.teacherCard1?.title }}</p>
      <div class="bar"></div>
      <p>
        {{ mydata.teacherCard1?.descr }}
      </p>
      <img src="@/assets/Vector (3).png" alt="" />
       <a @click="bookDonationButton(mydata.teacherCard1?.url)" target="_blank">
        <el-button type="primary" round class="elButton">{{
          mydata.teacherCard1?.button_text
        }}</el-button></a
      >
      <!-- <img src="@/assets/Vector.png" alt=""> -->
    </div>

    <!-- <div class="color-cards blue-box">
      <p>{{ info1.title }}</p>
      <div class="bar"></div>
      <p>
        {{ info1.intro }}
      </p>
      <img v-complete:src="info1.image" alt="" />
      <a
        href="https://www.jxks.org.cn/TeachingMagazine_pc/aboutUs.html"
        target="_blank"
      >
        <el-button type="primary" round class="elButton">了解平台</el-button></a
      >
    </div>
    <div class="color-cards green-box">
      <p>支持公益项目</p>
      <div class="bar"></div>
      <p>
        与新东方智慧教育联合支持中国教师发展基金会主办的“感谢恩师·你我同行”公益项目，活动已开展十余年，累计被感谢教师数十万名。
      </p>
      <img src="@/assets/Vector (2).png" alt="" />
      <a :href="info2" target="_blank">
        <el-button type="primary" round class="elButton">了解项目</el-button></a
      >
    </div>
    <div class="color-cards yellow-box">
      <p>图书捐赠活动</p>
      <div class="bar"></div>
      <p>
        天利教育与中国教师发展基金会共同发起公益图书捐赠活动，自2008年起，每年捐赠教辅图书2,000余万码洋，助力贫困学子成长成才。
      </p>
      <img src="@/assets/Vector (3).png" alt="" />
      <el-button
        type="primary"
        round
        class="elButton"
        @click="bookDonationButton"
        >申请捐赠</el-button
      >
    </div> -->
  </div>
</template>

<script setup>
import { reactive } from "vue";
import { useRouter } from "vue-router";

// 引入接口
import { teacherCardList } from "@/api/teacherHand/index.js";

const router = useRouter();

const mydata = reactive({
  // path: "",
  // 基础地址
  VUE_APP_BASE_HOST: process.env.VUE_APP_BASE_HOST,
});

const props = defineProps({
  // path: {
  //   type: String,
  //   // default: "",
  // },
  // info1: {
  //   type: Object,
  //   default: () => {
  //     return {};
  //   },
  // },
  // info2: {
  //   type: String,
  //   default:"",
  // },

  // teacherCardArr: [], //
});

function teacherCardFn() {
  teacherCardList().then((res) => {
    // mydata.teacherCardArr = res.data;
    mydata.teacherCard1 = res.data[0];
    mydata.teacherCard2 = res.data[1];
    mydata.teacherCard3 = res.data[2];
    // console.log(res.data, "教师卡片");
    // console.log(mydata.teacherCard1, "教师卡片1");
    // console.log(mydata.teacherCard2, "教师卡片2");
    // console.log(mydata.teacherCard3, "教师卡片3");
  });
}

teacherCardFn();

//教研合作媒体按钮点击事件
// function submitButton1(id) {
//   router.push({
//     // path: "/layout/list/collaborativeMediaDetails",
//     // query:{id}
//   });
// }

//支持公益项目
// function submitButton2(info2) {
//   router.push({
//     path: "/layout/list/collaborativeMediaDetails",
//   });
// }

//图书捐赠活动
function bookDonationButton(path) {
  // 如果是完整地址，那么先分割成数组再进行跳转；如果不是完整地址，那么直接跳转
  if (
    path.includes("http://") ||
    path.includes("https://") ||
    path.includes("#")
  ) {
    router.push({ path: path.split("#")[1] });
  } else {
    router.push({ path: path });
  }
}
</script>

<style scoped lang="scss">
/* 定制滚动条的大小和颜色 */
.color-box::-webkit-scrollbar {
    display: none;
    height:0px;
  }



.color-box {
  // width: 1200px;
  display: flex;
  justify-content: space-between;
  // background-color: transparent !important;
  // background-color: #f9f9f9;
 
  // overflow: visible;
   overflow-x: auto;
   padding:0px 16px;
  //  padding-right: 16px;
  //  border:1px solid red;

}
.color-cards {
  width: 343px;
  height: 216px;
  border: 1px solid rgb(38, 0, 255);
  border-radius: 10px;
  padding: 32px 30px;
  position: relative;
  flex-shrink: 0;
  
  // box-shadow: 0px 5px 40px 0px rgba(0, 0, 0, 0.0509803922);

  //   background-image: url("@/assets/Vector.png");
  //   background-position: 272px 32px;
  //   background-repeat: no-repeat;

  > p:nth-of-type(1) {
    color: #333333;
    font-size: 18px;
    font-weight: 700;
    
  }

  > .bar {
    width: 45px;
    height: 9px;
    // border:1px solid rgb(38, 0, 255);
    // background-color: #009de0;
    border-radius: 30px;
    margin-top: 11px;
    margin-bottom: 11px;
  }

  > p:nth-of-type(2) {
    width:283px;
    color: #666666;
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    display: -webkit-box;
    -webkit-box-orient: vertical; // 从上向下垂直排列子元素。设置或检索伸缩盒对象的子元素的排列方式 。
    text-overflow: ellipsis; //文本溢出 用省略号显示
    -webkit-line-clamp: 2; //几行
    overflow: hidden;
    position: absolute;
    z-index: 100;
    // border:1px solid rgb(38, 0, 255);
  }

  img {
    position: absolute;
    top: 38px;
    right: 30px;
  }

  :deep(.el-button.el-button--primary.is-round) {
    // border:1px solid red;
    width: 150px;
    height: 33px;
    // margin-top:25px;
    // margin-left:180px;
    // background-color: #009DE0;

    position: absolute;
    right: 30px;
    bottom: 32px;
    > span {
      font-size: 14px;
      font-weight: 400;
      color: #ffffff;
    }
  }
}

.blue-box {
  // background-image: url("@/assets/Vector.png");
  // background-position: 272px 32px;
  background: linear-gradient(90.86deg, #f1fbff 20.23%, #d1f1ff 96.21%);
  border: 1px solid #d2f2ff;
  margin-right: 16px;
  .bar {
    background-color: #009de0;
  }
}
.green-box {
  // background-image: url("@/assets/Vector (2).png");
  // background-position: 272px 32px;
  // background-repeat: no-repeat;
  background: linear-gradient(90.86deg, #f0fffe 20.23%, #c9fffc 96.21%);
  border: 1px solid #ccfffd;
  margin-right: 16px;
  .bar {
    background-color: #04d3c8;
  }
  :deep(.el-button.el-button--primary.is-round) {
    background-color: #04d3c8;
    border: none;
  }
}
.yellow-box {
  // background-image: url("@/assets/Vector (3).png");
  // background-position: 272px 32px;
  // background-repeat: no-repeat;
  background: linear-gradient(90.86deg, #fff7f3 20.23%, #fdf4ea 96.21%);
  border: 1px solid #f5c4ab57;
  .bar {
    background-color: #ff8b51;
  }
  :deep(.el-button.el-button--primary.is-round) {
    background-color: #ff8b51;
    border: none;
  }
}
</style>
